import module from 'recursoshumanos/module.js'
import template from './template.html'
import { isString } from 'lodash'

const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']

const tipoMovimientoRegex = /^[1278]$/
const nssRegex = /^\d{11}$/
const tipoSalarioRegex = /^[012]$/
const fechaMovimientoRegex = /^\d{4}\/\d{2}\/\d{2}$/
const tipoTrabajadorRegex = /^[01234]$/
const causaBajaRegex = /^[0123456789A]$/
const decodificarTipoMovimiento = (value) => {
  if (!tipoMovimientoRegex.test(value)) {
    throw `La clave del tipo de movimiento no es válida`
  }

  return value
}
const decodificarNss = (value) => {
  if (!nssRegex.test(value)) {
    throw `El número de seguro social no es válido`
  }

  return value
}
const decodificarSalarioBase = (value) => {
  value = Number(value.replace(/,/g, ''))
  if (!Number.isFinite(value)) {
    throw `El salario base no es un importe válido`
  }

  return value
}
const decodificarTipoSalario = (value) => {
  if (!tipoSalarioRegex.test(value)) {
    throw `La clave del tipo de salario del no es válida`
  }

  return value
}
const decodificarFechaMovimiento = (value) => {
  value = value.split('/').reverse().join('/')
  let fecha = new Date(value)
  if (!fechaMovimientoRegex.test(value) || Number.isNaN(fecha.getTime())) {
    throw `La fecha del movimiento no es válida`
  }

  return fecha
}
const decodificarTipoTrabajador = (value) => {
  if (!tipoTrabajadorRegex.test(value)) {
    throw `La clave del tipo de trabajador no es válida`
  }

  return value
}
const decodificarCausaBaja = (value) => {
  if (!causaBajaRegex.test(value)) {
    throw `La clave de la causa de baja no es válida`
  }

  return value
}

const decodificarPDF = (data) => {
  return data.split('\n')
    .map((renglon, indice) => {
      try {
        return {
          tipo_movimiento: decodificarTipoMovimiento(renglon.substring(0, 1)),
          nombre: renglon.substring(14, (renglon.indexOf('$') - 1)),
          nss: decodificarNss(renglon.substring(2, 13)),
          salario_base: decodificarSalarioBase(renglon.substring((renglon.indexOf('$') + 2), renglon.length - 23)),
          extemporaneo: renglon.substring(renglon.length - 22, renglon.length - 21),
          umf: renglon.substring(renglon.length - 20, renglon.length - 17),
          tipo_salario: decodificarTipoSalario(renglon.substring(renglon.length - 16, renglon.length - 15)),
          jornada_reducida: '',
          fecha_movimiento: decodificarFechaMovimiento(renglon.substring(renglon.length - 14, renglon.length - 4)),
          tipo_trabajador: decodificarTipoTrabajador(renglon.substring(renglon.length - 3, renglon.length - 2)),
          causa_baja: decodificarCausaBaja(renglon.substring(renglon.length - 1, renglon.length)),
          estatus: ['8', '3'].includes(renglon.substring(0, 1)),
        }
      } catch (error) {
        throw `Error en fila ${indice + 1}: ${error}`
      }
    })
}

const decodificarXls = (data) => {
  return data.split('\n')
    .map((renglon) => {
      let datos = renglon.split('\t')
      let tipo_movimiento = datos[0]
      let fecha = datos[8].split('-')

      if (!fecha[2]) throw 'Error al convertir la fecha de Script'

      return {
        tipo_movimiento: tipo_movimiento,
        nombre: datos[2],
        nss: datos[1],
        salario_base: datos[3].replace(/\$,/g, ''),
        extemporaneo: datos[4] === 'SI' ? 1 : 0,
        umf: datos[5],
        tipo_salario: datos[6],
        jornada_reducida: datos[7],
        fecha_movimiento: `20${fecha[2]}-${('00' + (meses.indexOf(fecha[1]) + 1)).slice(-2)}-${fecha[0]}`,
        tipo_trabajador: datos[9],
        causa_baja: datos[10] === '-' ? 0 : 1,
        estatus: (tipo_movimiento === '8' || tipo_movimiento === '3'),
      }
    })
}

export class RecursoshumanosCargarmovimientosDecodificadorComponent {
  onChange
  input = ''
  error = null
  procesando = false

  limpiar () {
    this.input = ''
    this.error = null
  }

  procesar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    try {
      const data = decodificarPDF(this.input)
      this.onChange({$event: {detail: {data}}})
    } catch (error) {
      this.error = isString(error) ? `Error: ${error}` : 'Se generó un error al decodificar la información'
    } finally {
      this.procesando = false
    }
  }
}

module.component('recursoshumanosCargarmovimientosDecodificador', {
  controller: RecursoshumanosCargarmovimientosDecodificadorComponent,
  template,
  bindings: {
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/decodificador/component.js